import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import { useTooltipTrigger } from '@react-aria/tooltip';
import { useTooltipTriggerState } from '@react-stately/tooltip';
import classNames from 'classnames';
import { PureButton } from '../../basics';
import { TooltipPlacement, TooltipTriggerMode } from '../../enums';
import { TooltipVariant } from '../../enums/tooltipVariant';
import { Tooltip } from './Tooltip';
import styles from './Tooltip.module.scss';
const TooltipButton = ({ a11yCloseButton, a11yLabel, children, onClick, props, tooltip, tooltipClassName, tooltipPlacement, triggerMode = TooltipTriggerMode.Hover, variant = TooltipVariant.Default, ...restProps }) => {
    const [isOpen, setIsOpen] = useState(false);
    const state = useTooltipTriggerState({ isOpen, onOpenChange: setIsOpen, ...props });
    const ref = useRef();
    const tooltipDefaultProps = props || {};
    const { tooltipProps, triggerProps } = useTooltipTrigger(tooltipDefaultProps, state, ref);
    const finalTooltipPlacement = variant === TooltipVariant.Nudging ? TooltipPlacement.Top : tooltipPlacement;
    return (_jsxs("div", { className: classNames('d-inline-block position-relative', styles.container), children: [_jsx(PureButton, { "aria-label": a11yLabel, ref: ref, ...restProps, ...(triggerMode === TooltipTriggerMode.Hover ? triggerProps : {}), onClick: e => {
                    onClick(e);
                    setIsOpen(!isOpen);
                }, children: children }), state.isOpen && (_jsx(Tooltip, { placement: finalTooltipPlacement, state: state, props: tooltipProps, variant: variant, a11yCloseButton: a11yCloseButton, onCloseClick: () => setIsOpen(false), className: tooltipClassName, children: tooltip }))] }));
};
export { TooltipButton };
